function Navbar(){
    return(
        <div className="navbar-block">
            <img src="https://seeklogo.com/images/T/troll-face-logo-A3A07A678C-seeklogo.com.png" alt=" " className="main-logo" />
            <span className="main-heading">Meme Generator</span>
        </div>
    );
}
export default Navbar;